import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import { fonts } from '../theme-keys/fonts.esm.js';
import { anchors } from '../theme-keys/anchors.esm.js';
import buttons from '../theme-keys/buttons.esm.js';
import { cards } from '../theme-keys/cards.esm.js';
import { badges } from '../theme-keys/badges.esm.js';
import textarea from '../theme-keys/textarea.esm.js';
import radio from '../theme-keys/radio.esm.js';
import { tabs } from '../theme-keys/tabs.esm.js';
import { text } from '../theme-keys/text.esm.js';
import { tooltips } from '../theme-keys/tooltips.esm.js';
import { headings } from '../theme-keys/headings.esm.js';
import { fodal } from '../theme-keys/fodals.esm.js';
import { tables } from '../theme-keys/tables.esm.js';
import { typeahead } from '../theme-keys/typeahead.esm.js';

var cosmosTheme = _objectSpread2(_objectSpread2({
  contextId: 'cosmos'
}, fonts), {}, {
  colors: {
    text: 'black'
  },
  anchors: anchors,
  buttons: buttons,
  cards: cards,
  badges: badges,
  forms: {
    textarea: textarea,
    radio: radio
  },
  tabs: tabs,
  text: text,
  tooltips: tooltips,
  headings: headings,
  fodal: fodal,
  tables: tables,
  typeahead: typeahead
});

export default cosmosTheme;
//# sourceMappingURL=cosmos-theme.esm.js.map
